export function insertAtCursor(
  value: string,
  insert: string,
  start: number,
  end: number,
): { next: string; caret: number } {
  const from = Math.max(0, Math.min(start, value.length));
  const to = Math.max(from, Math.min(end, value.length));
  return {
    next: `${value.slice(0, from)}${insert}${value.slice(to)}`,
    caret: from + insert.length,
  };
}
